import { render, staticRenderFns } from "./acceptFile.vue?vue&type=template&id=1111430e&scoped=true"
import script from "./acceptFile.vue?vue&type=script&lang=js"
export * from "./acceptFile.vue?vue&type=script&lang=js"
import style0 from "./acceptFile.vue?vue&type=style&index=0&id=1111430e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1111430e",
  null
  
)

export default component.exports